var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.337,
    height: 26.625,
    viewBox: "0 0 26.337 26.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(-1212.969 -1936.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_552",
    "data-name": "Path 552",
    transform: "translate(391.423 993.359)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.291,951.1v18.432h-4.744V942.906h26.337v26.624h-5.049V951.124Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823.0465087890625 944.4060668945312 L 823.0465087890625 968.030517578125 L 824.7908935546875 968.030517578125 L 824.7908935546875 951.0989990234375 C 824.7908935546875 950.7008056640625 824.94921875 950.3189086914062 825.2310180664062 950.0375366210938 C 825.5122680664062 949.7567138671875 825.8934936523438 949.5989990234375 826.2908935546875 949.5989990234375 C 826.2916870117188 949.5989990234375 826.2924194335938 949.5989990234375 826.2931518554688 949.5989990234375 L 842.8377075195312 949.6241455078125 C 843.665283203125 949.6254272460938 844.33544921875 950.296630859375 844.33544921875 951.1241455078125 L 844.33544921875 968.030517578125 L 846.3839721679688 968.030517578125 L 846.3839721679688 944.4060668945312 L 823.0465087890625 944.4060668945312 M 821.5465087890625 942.9060668945312 L 847.8839721679688 942.9060668945312 L 847.8839721679688 969.530517578125 L 842.83544921875 969.530517578125 L 842.83544921875 951.1241455078125 L 826.2908935546875 951.0989990234375 L 826.2908935546875 969.530517578125 L 821.5465087890625 969.530517578125 L 821.5465087890625 942.9060668945312 Z",
    stroke: "none",
    fill: "#005682"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x2: 16.885,
    transform: "translate(1217.522 1961.52)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x2: 0.077,
    y2: 17.314,
    transform: "translate(1226.086 1944.203)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M851.148,955.258l1.635-1.541,1.415,1.541",
    transform: "translate(369.832 985.477)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M878.034,953.717l1.635,1.541,1.415-1.541",
    transform: "translate(350.223 985.477)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.dbe1399df0c476b87f756b4640abd274.svg";
export { ForwardRef as ReactComponent };